import { Page } from '@packages/ui/layout';
import { DynamicTableV2 } from '@packages/table-builder';
import { invalidPasswordResetAnalyticsTable } from './schema';
import { axiosInstance } from '@/services/apiInterceptor';

export default function InvalidPasswordResetAnalyticsPage() {
  return (
    <Page
      semanticId='invalidPasswordResetAnalyticsPage'
      title='Invalid Password Reset Email Analytics'
      subtitle='Track failed password reset attempts where the entered username is not recognized in the system'
      style={{ padding: 0 }}
    >
      <DynamicTableV2
        schema={invalidPasswordResetAnalyticsTable}
        axiosInstance={axiosInstance}
      />
    </Page>
  );
}
